// extracted by mini-css-extract-plugin
module.exports = {"questionBlock":"Question_questionBlock__XiJcM","questionBlock__icon":"Question_questionBlock__icon__NgL_1","spin":"Question_spin__83fkI"};